export default "__VITE_ASSET__DhagZjZd__";